import { render, staticRenderFns } from "./SideDetail.vue?vue&type=template&id=2869cb4c&"
import script from "./SideDetail.vue?vue&type=script&lang=js&"
export * from "./SideDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports